<template>

    <div>
        <div class="mapsHead" style="z-index: 500;">
            <van-nav-bar left-arrow @click-left="returnNav"></van-nav-bar>
            <van-search
                    style="margin-left: 22px;background: rgb(52, 133, 251);width: 94vw"
                    placeholder="请输入小区名或地址"
                    v-model="searchVal"
                    shape="round"
                    background="#3485FB"
                    @search="onSearch('query')"
                    @clear="onSearch('query')"
            >
            </van-search>
        </div>
        <van-pull-refresh v-if="listSH" v-model="isLoading" @refresh="onRefresh"
                          style="position: fixed;top: 3.4rem;z-index: 1200;overflow-y:auto;background-color: white;width: 100%;">
            <van-list :style="{'height':heightV}" v-model="loading" :finished="finished" finished-text="没有更多数据了"
                      :error.sync="error" :immediate-check="false" error-text="请求失败，点击重新加载" @load="onLoad"
			>
                <van-cell v-for="item in regions" :key="item.regionId" :title="item.regionName"
                          @click="searchCli(item)"/>
            </van-list>
        </van-pull-refresh>
        <div id="container" ref="container" style="z-index: 3;"></div>
        <div class="location" style="z-index:500;">
            <!--<van-icon name="wap-home" color="#000000" size="40px" @click="goStart" />-->
            <bv-icon icon-class="start" @click="goStart"/>
        </div>
    </div>
</template>
<script>
    /* eslint-disable */
    import {NavBar, Toast, Dialog} from 'vant'
    import {mapRegions, divisions, fetchRegions} from '@/api/houseResource/region'
    import {jsApiSignature} from '@/api/wx'
    import wx from "weixin-js-sdk";

    const centerPosition = [118.916202, 42.271235]

    var map;
    export default {
        name: 'Maps',
        components: {
            VanNavBar: NavBar,
            Dialog: Dialog
        },
        data() {
            return {
                heightV: (window.innerHeight) - 55 + 'px',
                listSH: false,
                signRes: {
                    appId: '',
                    nonceStr: '',
                    signature: '',
                    timestamp: ''
                },
                rowRegionsVal: [],
                centerPositionX: "",
                centerPositionY: "",
                mapSH: true,
                searchVal: "",
                addressQuery: '',
                //分页
                currentPage: 1,
                pageCount: 1,
                pageSize: 30,
                division: '',
                avgPrice: '',
                houseHold: '',
                order: '',
                regions: [],
                //下拉刷新
                isLoading: false,
                //滑动底部加载状态
                loading: false,
                //数据是否全部加载完毕
                finished: false,
                error: false,
            }
        },
        methods: {
            searchCli(item) {
                let _vm = this;
                this.searchVal = item.regionName;
                this.isLoading = false;
                this.loading = false;
                this.finished = true;
                this.centerPositionX = item.x;
                this.centerPositionY = item.y;
                this.rowRegionsVal.push(item);
                this.listSH = false;
                _vm.initMaps();
            },
            //搜索框左侧返回按钮
            returnNav() {
                this.$router.go(-1);
            },
            //瀑布流加载触发
            onLoad() {
                //滑动底部加载
                setTimeout(() => {
                    this.currentPage = this.currentPage + 1;
                    let param = {
                        pageNo: this.currentPage,
                        pageSize: this.pageSize,
                        divisionCode: this.division,
                        avgPrice: this.avgPrice,
                        houseHold: this.houseHold,
                        order: this.order,
                        keywords: this.keywords
                    };
                    fetchRegions(param).then(res => {
                        this.listSH = true;
                        this.regions = this.regions.concat(res.data.list);
                        this.pageCount = res.data.page.totalPage;

                        // 加载状态结束
                        this.loading = false;

                        // 数据全部加载完成
                        if (this.currentPage == this.pageCount) {
                            this.finished = true;
                        }
                    }).catch(() => {
                        this.error = true;
                    });
                }, 500);
            },
            //下拉刷新
            onRefresh() {
                this.currentPage = 1;
                let param = {
                    pageNo: this.currentPage,
                    pageSize: this.pageSize,
                    divisionCode: this.division,
                    avgPrice: this.avgPrice,
                    houseHold: this.houseHold,
                    order: this.order,
                    keywords: this.searchVal
                };
                fetchRegions(param).then(res => {
                    this.listSH = true;
                    this.regions = res.data.list;
                    this.pageCount = res.data.page.totalPage;
                    if (this.currentPage === this.pageCount || this.pageCount === 0) {
                        this.finished = true;
                    } else {
                        this.finished = false;
                    }
                    this.isLoading = false;
                });
            },
            //搜索框搜索
            onSearch(value) {
                var _vm = this;
                _vm.finished = true;
                //显示全屏加载
                _vm.showLoading();
                _vm.currentPage = value == 'page' ? _vm.currentPage : 1;
                let param = {
                    pageNo: _vm.currentPage,
                    pageSize: _vm.pageSize,
                    divisionCode: _vm.division,
                    avgPrice: _vm.avgPrice,
                    houseHold: _vm.houseHold,
                    order: _vm.order,
                    keywords: _vm.searchVal
                };
                fetchRegions(param).then(res => {
                    _vm.listSH = true;
                    _vm.regions = res.data.list;
                    _vm.pageCount = res.data.page.totalPage;
                    if (_vm.currentPage == _vm.pageCount || _vm.pageCount == 0) {
                        _vm.finished = true;
                    } else {
                        _vm.finished = false;
                    }
                    //取消全屏加载
                    Toast.clear();
                });
            },
            //全屏加载提示
            showLoading() {
                Toast.loading({
                    // 持续展示 toast
                    duration: 0,
                    mask: true,
                    message: '加载中...'
                });
            },
            toHome() {
                this.$router.push('/houseResource')
            },
            goStart() {
                map.panTo(new BMapGL.Point(118.916202, 42.271235));
                //  this.$router.go(0)
            },
            onMapRegions: function () {
                let _vm = this;
                mapRegions().then(res => {
                    var regions = res.data;
                    for (var i = 0; i < regions.length; i++) {
                        var region = regions[i];
                        if (isNaN(region.x) || isNaN(region.y)) {
                            continue;
                        }
                        if (region.x == null || region.y == null) {
                            continue;
                        }

                        // 高德坐标转换为百度坐标
                        let x = region.x
                        let y = region.y
                        // let x_pi = 3.14159265358979324 * 3000.0 / 180.0
                        // let z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * x_pi)
                        // let theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * x_pi)
                        // let lng = z * Math.cos(theta) + 0.0065
                        // let lat = z * Math.sin(theta) + 0.006

                        // 点标记显示内容，HTML要素字符串
                        var labelContent =
                            '<div class="region" id="' + region.regionId + 'Div">'
                            + '<p class="region-text">' + region.regionName + '</p>'
                            + '<i class="region-jiantou"></i>'
                            + '</div>';
                        let label = new BMapGL.Label(labelContent, {
                            position: new BMapGL.Point(x, y),
                            // 以 icon 的 [center bottom] 为原点
                            // offset: new BMapGL.Size(-50, -27),
                            extData: {
                                id: region.regionId,
                                region: region
                            }
                        });
                        label.setStyle({
                            border: "0",
                            backgroundColor: "0.05"
                        })
                        // 将 labels 添加到地图
                        map.addOverlay(label);
                        // 给label附点击事件
                        label.addEventListener("click", function () {
                            _vm.$router.push(
                                {
                                    path: '/houseResource/sales',
                                    query: {
                                        regionId: this.regionId,
                                        regionName: encodeURIComponent(this.regionName),
                                        from: 'maps'
                                    }
                                }
                            )
                        }, region);
                    }
                });
            },
            initMaps: function () {
                let _vm = this;
                //创建地图
                map = new BMapGL.Map('container'); // 创建Map实例
                map.centerAndZoom(new BMapGL.Point(118.916202, 42.271235), 12); // 初始化地图,设置中心点坐标和地图级别
                map.enableScrollWheelZoom(true); // 开启鼠标滚轮缩放

                var zoomCtrl = new BMapGL.ZoomControl({  // 添加缩放控件
                    anchor: BMAP_ANCHOR_TOP_LEFT,
                    offset: new BMapGL.Size(20, 70)
                });
                map.addControl(zoomCtrl);

                // 地图缩放，刷新业务数据
                map.addEventListener('zoomend', function () {
                    _vm.onMapRefresh(map);
                });

                // 地图加载完成，刷新业务数据
                map.addEventListener('tilesloaded', function () {
                    _vm.onMapRefresh(map);
                });
            },
            mapDot: function () {
                let _vm = this;
                var labelContent = '' +
                    '<div style="display: flex;flex-direction: row;justify-content: center;">' +
                    '   <img src="http://webapi.amap.com/theme/v1.3/markers/n/mark_r.png">' +
                    '   <span style="color: white;justify-content: center;position: absolute">终</span>' +
                    '</div>';
                // 高德坐标转换为百度坐标
                let x = this.centerPositionX
                let y = this.centerPositionY
                // let x_pi = 3.14159265358979324 * 3000.0 / 180.0
                // let z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * x_pi)
                // let theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * x_pi)
                // let lng = z * Math.cos(theta) + 0.0065
                // let lat = z * Math.sin(theta) + 0.006

                let label = new BMapGL.Label(labelContent, {
                    position: new BMapGL.Point(x, y),
                    offset: new BMapGL.Size(0, 0)
                });
                label.setStyle({
                    border: "0",
                    backgroundColor: "0.05"
                })

                // var marker = new BMapGL.Marker(new BMapGL.Point(x, y))

                // map.add([marker]);
                map.addOverlay(label);
                // 给label附点击事件
                label.addEventListener("click", function () {
                    Dialog.alert({
                        title: _vm.rowRegionsVal[0].regionName,
                        message: _vm.rowRegionsVal[0].address,
                        cancelButtonText: "详情",
                        confirmButtonText: "导航去这儿",
                        showCancelButton: true,
                        showConfirmButton: true
                    }).then(() => {
                        // url是外网可访问地址（域名）
                        let url = location.href.split('#')[0];
                        //传url给后台,从后台获取appId/timestamp/nonceStr/signature
                        jsApiSignature({url: url}).then(res => {
                            var resV = res.data;
                            _vm.signRes.appId = resV.appId;
                            _vm.signRes.nonceStr = resV.nonceStr;
                            _vm.signRes.signature = resV.signature;
                            _vm.signRes.timestamp = resV.timestamp.toString();
                            wx.config({
                                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                                appId: _vm.signRes.appId, // 必填，公众号的唯一标识
                                timestamp: _vm.signRes.timestamp, // 必填，生成签名的时间戳
                                nonceStr: _vm.signRes.nonceStr, // 必填，生成签名的随机串
                                signature: _vm.signRes.signature,// 必填，签名
                                jsApiList: ['openLocation'] // 必填，需要使用的JS接口列表
                            });
                        }).catch(error => {
                            Toast.fail("签名接口异常，请联系管理员！")
                        })
                        // 通过ready接口处理config成功验证
                        wx.ready(function () {
                            wx.openLocation({
                                latitude: _vm.rowRegionsVal[0].y,
                                longitude: _vm.rowRegionsVal[0].x,
                                scale: 14,
                                name: _vm.rowRegionsVal[0].regionName,
                                address: _vm.rowRegionsVal[0].address,
                                success: function (openLoc) {
                                    console.log("打开内置地图成功后的回调" + openLoc)
                                },
                                fail: function () {
                                    Toast.fail("打开位置异常，请联系管理员！")
                                },
                            })
                        })
                        // 通过error接口处理config失败验证
                        wx.error(function (e) {
                            Toast.fail("验证签名接口异常，请联系管理员！")
                        });
                    }).catch(() => {
                        _vm.$router.push(
                            {
                                path: '/houseResource/sales',
                                query: {
                                    regionId: _vm.rowRegionsVal[0].regionId,
                                    regionName: encodeURIComponent(_vm.rowRegionsVal[0].regionName),
                                    address: encodeURIComponent(_vm.rowRegionsVal[0].address),
                                    x: _vm.rowRegionsVal[0].x,
                                    y: _vm.rowRegionsVal[0].y,
                                    from: 'maps'
                                }
                            }
                        )
                    })
                });
            },
            onMapRefresh: function (map) {
                let _vm = this;
                // 地图加载完成，刷新业务数据
                var zoom = map.getZoom();
                map.clearOverlays();
                if (zoom >= 14) { // 刷项目
                    // 获取项目加载点
                    _vm.onMapRegions();
                    setTimeout(() => {
                        _vm.mapDot()
                    }, 500)
                } else if (zoom <= 13) { // 刷行政区
                    // 获取项目加载点
                    _vm.onMapDivisions();
                    setTimeout(() => {
                        _vm.mapDot()
                    }, 500)
                }
            },
            onMapDivisions: function () {
                let _vm = this;
                divisions().then(res => {
                    var divisions = res.data;
                    for (var i = 0; i < divisions.length; i++) {
                        var division = divisions[i];
                        if (isNaN(division.x) || isNaN(division.y)) {
                            continue;
                        }
                        if (division.x == null || division.y == null) {
                            continue;
                        }
                        // 点标记显示内容，HTML要素字符串
                        var labelContent =
                            '<div class="division">'
                            + division.name
                            + '</div>';
                        let label = new BMapGL.Label(labelContent, {
                            position: new BMapGL.Point(division.x, division.y),
                            offset: new BMapGL.Size(0, 0),
                            extData: {
                                division: division
                            }
                        });
                        label.setStyle({
                            border: "0",
                            backgroundColor: "0.05"
                        })
                        // 将 labels 添加到地图
                        map.addOverlay(label);
                        // 给label附点击事件
                        label.addEventListener("click", function () {
                            map.setZoom(14);
                            _vm.onMapRefresh(map);
                        });
                    }
                });
            }
        },
        mounted: function () {
            this.$refs.container.style.width = window.innerWidth + 'px';
            this.$refs.container.style.height = window.innerHeight + 'px';
            // 初始加载地图
            this.initMaps();
        }
    }
</script>
<style lang="scss" scoped>
    .custom-content-marker {
        position: relative;
        width: 25px;
        height: 34px;
    }

    .custom-content-marker span {
        position: absolute;
    }

    .custom-content-marker img {
        width: 120%;
        height: 100%;
    }

    .custom-content-marker .close-btn {
        position: absolute;
        top: -6px;
        right: -8px;
        width: 15px;
        height: 15px;
        font-size: 12px;
        background: #ccc;
        border-radius: 50%;
        color: #fff;
        text-align: center;
        line-height: 15px;
        box-shadow: -1px 1px 1px rgba(10, 10, 10, .2);
    }

    .custom-content-marker .close-btn:hover {
        background: #666;
    }

    .mapsHead {
        position: fixed;
        z-index: 1;
        justify-content: space-between;
        display: flex;
        flex-direction: row;
        background-color: #3485fb;

        .van-nav-bar {
            height: 48px;

            .van-nav-bar__left {
                left: 8px;
            }

            .van-icon {
                color: white;
            }
        }
    }

    .division {
        width: 54px;
        height: 54px;
        background-color: rgba(0, 167, 91, 0.9);
        border-radius: 50%;
        overflow: hidden;
        line-height: 54px;
        font-size: 16px;
        font-weight: 400;
        text-align: center;
        color: #fff;
        cursor: pointer;
        webkit-transition: background-color .15s ease-in-out;
        -moz-transition: background-color .15s ease-in-out;
        -o-transition: background-color .15s ease-in-out;
        transition: background-color .15s ease-in-out;
    }

    .division:hover {
        background-color: rgba(255, 0, 0, 0.9);
    }

    .region {
        line-height: 24px;
        cursor: pointer;
        color: #fff;
        font-size: 14px;
        font-weight: 400;
        text-align: center;
        display: inline-block;
    }

    .region-text {
        margin: 0;
        padding: 2px 10px;
        border-radius: 3px;
        background-color: rgba(0, 167, 91, 0.9);
        white-space: nowrap;
    }

    .region-jiantou {
        border: 5px solid transparent;
        display: block;
        width: 0;
        height: 0;
        margin: 0 auto;
        border-top-color: rgba(0, 167, 91, 0.9);
    }

    .region:hover .region-text {
        background-color: rgba(255, 0, 0, 0.9);
    }

    .region:hover .region-jiantou {
        border-top-color: rgba(255, 0, 0, 0.9);
    }

    .location {
        position: absolute;
        top: 92%;
        left: 5%;
        border-radius: 5px;
        width: 35px;
        height: 35px;
        background-color: white;
        text-align: center;
        padding-top: 10px;
    }
</style>
